import React from 'react';
import { Card, Slider, Typography, Button, Alert, Input } from 'antd';
import { RiseOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { TextArea } = Input;

export default function ActionProgressTab({
  progressPercent,
  setProgressPercent,
  progressComment,
  setProgressComment,
  progressLoading,
  onUpdateProgress,
  primaryButtonClass,
}) {
  return (
    <Card style={{ borderRadius: 16 }} bodyStyle={{ padding: 16 }}>
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
        <div>
          <Title level={5} style={{ margin: 0, fontFamily: 'CustomFont' }}>
            به‌روزرسانی پیشرفت
          </Title>
          <Text type="secondary" style={{ fontFamily: 'CustomFont' }}>
            فقط کاربر با نقش <Text strong>مسئول اجرا</Text> می‌تواند پیشرفت را به‌روزرسانی کند.
          </Text>
        </div>
        <Button
          type="primary"
          icon={<RiseOutlined />}
          onClick={onUpdateProgress}
          loading={progressLoading}
          className={primaryButtonClass}
          style={{ borderRadius: 14, fontFamily: 'CustomFont' }}
        >
          ثبت پیشرفت
        </Button>
      </div>

      <div className="mt-4">
        <Text style={{ fontFamily: 'CustomFont' }} strong>
          درصد پیشرفت: {progressPercent}%
        </Text>
        <Slider
          className="mt-2"
          min={0}
          max={100}
          step={1}
          value={progressPercent}
          onChange={(v) => setProgressPercent(v)}
        />
      </div>

      <div className="mt-4">
        <Text style={{ fontFamily: 'CustomFont' }} strong>
          توضیحات (اختیاری)
        </Text>
        <TextArea
          value={progressComment}
          onChange={(e) => setProgressComment(e.target.value)}
          rows={4}
          maxLength={1000}
          showCount
          placeholder="مثلاً: ۷۵ درصد کار انجام شده است"
          style={{ marginTop: 8, borderRadius: 14 }}
        />
      </div>

      <Alert
        className="mt-4"
        type="info"
        showIcon
        message={
          <span style={{ fontFamily: 'CustomFont' }}>
            درصد پیشرفت باید بین ۰ تا ۱۰۰ باشد.
          </span>
        }
      />
    </Card>
  );
}
